import React from 'react';

const Nav = () => {
  const navItems = [
    { label: 'Home', href: '/' },
    { label: 'Services', href: '#services' },
    { label: 'Solutions', href: '#solutions' },
    { label: 'Process', href: '#our-process' },
  ];

  return (
    <nav className="hidden lg:flex items-center gap-1">
      {navItems.map((item) => (
        <a
          key={item.label}
          href={item.href}
          className="relative px-5 py-2.5 text-sm font-medium text-dark-600 rounded-xl transition-all duration-300 hover:text-primary-600 group"
        >
          <span className="relative z-10">{item.label}</span>
          <span className="absolute inset-0 rounded-xl bg-primary-50 scale-90 opacity-0 transition-all duration-300 group-hover:scale-100 group-hover:opacity-100" />
        </a>
      ))}
    </nav>
  );
};

export default Nav;
